import style from './style.module.scss'
import { useSelector } from 'react-redux'
import { getMyAffiliates, getUser } from 'store/selectors'
import Routes from 'components/App/Routes'
import Header from 'components/Header'
import { Toaster } from 'react-hot-toast'
import { useEffect } from 'react'
import { BannerContextProvider } from 'contexts/Banner'
import { MyAffiliate, User } from 'types'
import useBanners from 'hooks/useBanner'
import LockedOutPage from 'pages/LockedOut'

function App() {
  useBanners()
  const affiliates = useSelector(getMyAffiliates)
  const isAffiliateLockedOut =
    affiliates?.selectedAffiliate?.affiliateId &&
    affiliates?.selectedAffiliate?.affiliateStanding !== 'good'
  const user = useSelector(getUser) as User
  const affiliate = useSelector(getMyAffiliates)
    .selectedAffiliate as MyAffiliate

  useEffect(() => {
    if (user && (window.needsToIdentify || window.needsToIdentify == null)) {
      analytics.identify(`${user.id}`, {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        affiliateRole:
          affiliate?.roles?.length > 0 ? affiliate?.roles[0] : null,
      })

      window.needsToIdentify = false
    }
  }, [user])

  useEffect(() => {
    if (user && affiliate) {
      analytics.identify(`${user.id}`, {
        affiliateRole:
          affiliate?.roles?.length > 0 ? affiliate?.roles[0] : null,
      })
    }
  }, [affiliate])

  return (
    <div className={style.wrapper}>
      <BannerContextProvider>
        <Header />
        {isAffiliateLockedOut ? <LockedOutPage /> : <Routes />}
        <Toaster />
      </BannerContextProvider>
    </div>
  )
}

export default App
